import React from 'react';
import { ITableCell, TableColumnAlignment } from '../../parser/table';
import { TextAlign } from './text-align';

interface IPRIVATE_MARKDOWN_TABLE_CELLProps {
  cell: ITableCell,
  isHeaderCell: boolean;
  columnAlignment: TableColumnAlignment;
}

export const PRIVATE_MARKDOWN_TABLE_CELL: React.FunctionComponent<IPRIVATE_MARKDOWN_TABLE_CELLProps> = (props) => {
  const { cell } = props;
  const colspan = cell.colspan > 1 ? cell.colspan : undefined;
  const textAlign = props.columnAlignment !== TableColumnAlignment.Default ?
    TableColumnAlignment[props.columnAlignment].toLowerCase() as TextAlign : undefined;

  return (
    <>
      {props.isHeaderCell ?
      <th colSpan={colspan} style={{ textAlign }} dangerouslySetInnerHTML={{ __html: cell.content }} />
      :
      <td colSpan={colspan} style={{ textAlign }} dangerouslySetInnerHTML={{ __html: cell.content }} />}
    </>
  );
};
